export default "assets/images/ffea4dd10bf2506aa1e0cd4c61426b42.png";